import { createAsyncReducer } from '@telstra-connect/standard-actions/reducers';
import {
    ILoadMergeTestServiceIdValidationAction,
    ILoadMergeTestServiceIdValidationSuccessAction,
    ILoadMergeTestServiceIdValidationErrorAction
} from '@telstra-connect/tickets/actions/service/merge/load-merge-service-id-validation';
import { ITicketsState } from '../state';
import { initialState } from './initial-state';

export type MergeTestServiceIdValidationAction
    = ILoadMergeTestServiceIdValidationAction
    | ILoadMergeTestServiceIdValidationSuccessAction
    | ILoadMergeTestServiceIdValidationErrorAction;

const init = (state: ITicketsState, action: MergeTestServiceIdValidationAction) => ({
    ...state,
    mergeTestServiceIdValidationRequest: {
        ...initialState.mergeTestServiceIdValidationRequest,
        status: action.status,
    }
});

const success = (state: ITicketsState, action: MergeTestServiceIdValidationAction) => ({
    ...state,
    mergeTestServiceIdValidationRequest: {
        ...initialState.mergeTestServiceIdValidationRequest,
        status: action.status,
        mergeTestServiceIdValidation:
            (action as ILoadMergeTestServiceIdValidationSuccessAction).mergeTestServiceIdValidation
    }
});

const failure = (state: ITicketsState, action: MergeTestServiceIdValidationAction) => ({
    ...state,
    mergeTestServiceIdValidationRequest: {
        ...initialState.mergeTestServiceIdValidationRequest,
        status: action.status,
        error: (action as ILoadMergeTestServiceIdValidationErrorAction).error
    }
});

export const mergeTestServiceIdValidationReducer = createAsyncReducer(initialState, init, success, failure);
